module.exports = __webpack_public_path__ + "img/filter.0d7f9b3c.svg";